import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { SpendingLimits } from '../../Dashboard.types';
import styles from '../SpendingLimitDrawer.module.css';
import { UnavailableLimit } from './UnavailableLimit';
import { Button, Icon, Pill } from '@iwoca/orion';

export const ExpiredLimitDrawer = ({
    spendingLimits,
    refreshSpendingLimit,
    loadingRefreshSpendingLimit,
    isError
}: {
    spendingLimits: SpendingLimits;
    refreshSpendingLimit: () => Promise<void>;
    loadingRefreshSpendingLimit: boolean;
    isError: boolean;
}) => {
    return (
        <>
            <div className={styles.spendingLimits}>
                {Object.keys(spendingLimits.limits).map((key) => {
                    const spendingLimit =
                        spendingLimits.limits[
                            key as keyof typeof spendingLimits.limits
                        ];

                    if (!spendingLimit)
                        return (
                            <UnavailableLimit
                                sellerProduct={
                                    key as keyof typeof spendingLimits.limits
                                }
                                key={key}
                            />
                        );

                    return (
                        <div key={key}>
                            <div className={styles.loanDuration}>
                                {spendingLimit.durationInMonths} months
                                purchases
                            </div>
                            <div className={styles.leftToSpend}>
                                Left to spend:
                            </div>
                            <div className={styles.creditLimitContainer}>
                                <FormattedCurrency
                                    className={styles.creditLimit}
                                    value={spendingLimit.creditLimit}
                                />
                                <Pill className={styles.estimatedPill}>
                                    Estimated
                                </Pill>
                            </div>
                            <div className={styles.maxLimit}>
                                Estimated spending limit:{' '}
                                <FormattedCurrency
                                    value={spendingLimit.maxCreditLimit}
                                />
                            </div>
                        </div>
                    );
                })}
                <div>
                    <Button
                        disabled={loadingRefreshSpendingLimit}
                        onClick={refreshSpendingLimit}
                        className={styles.refreshButton}
                    >
                        {loadingRefreshSpendingLimit ? (
                            <>
                                <Icon
                                    icon="sync"
                                    className={styles.spinningIcon}
                                />
                                Checking limits...
                            </>
                        ) : (
                            <>
                                <Icon icon="sync" />
                                Secure my limits
                            </>
                        )}
                    </Button>
                    {isError && (
                        <div className={styles.errorMessage}>
                            Something went wrong
                        </div>
                    )}
                </div>
            </div>
            <div className={styles.footer}>
                <div>
                    *Your spending limits are subject to approval and reassessed
                    every 30 days - if something changes with your business the
                    amounts might change.
                </div>
            </div>
        </>
    );
};
